import React from "react";

const AuthExpiredModal = ({ visible, onClose, language }) => {
  if (!visible) return null;

  const isEnglish = language === "en";

  return (
    <div className="modal-backdrop">
      <div className="modal-box">
        <h2>🔒 {isEnglish ? "Authorization expired" : "ავტორიზაცია გაუქმდა"}</h2>
        <p>
          {isEnglish
            ? "Your session has expired. Please log in again to continue."
            : "მოხდა სისტემიდან გამოსვლა, გთხოვთ გაიაროთ ავტორიზაცია ხელახლა."}
        </p>
        <button onClick={onClose}>
          {isEnglish ? "Continue" : "გაგრძელება"}
        </button>
      </div>
    </div>
  );
};

export default AuthExpiredModal;
